import { FormattedMessage, useIntl } from "react-intl";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import MainDepartment from "component/shared/main-department/MainDepartment.jsx";
import AboutDepartment from "component/shared/about-department/AboutDepartment.jsx";
import HtmlView from "component/htmlView/html-view.js";
import { LabelLangString } from "component/LabelLang/label-lang.js";
import { useSubscribeForm } from "./useSubscribeForm";
import RegisterForm from "./components/RegisterForm";
import "./SubscribeForm.scss";

function SubscribeForm() {
  const intl = useIntl();
  const form = useSubscribeForm();
  const { currentLocale, isLoading, getDepartment, getServices } = form;

  return (
    <ContentLoading isLoading={isLoading}>
      <div className="subscribe">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "subscribe" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "subscribe-to-CAPMAS" })}
          route={"../servicestools"}
        />
        <div className="container py-5">
          <div className="row gy-lg-0 gy-4">
            <div className="col-12 col-lg-8">
              <RegisterForm {...form} />
            </div>
            <div className="col-12 col-lg-4">
              <AboutDepartment
                id="about"
                txt={getServices?.data?.data?.about}
                translations={
                  getServices?.data?.data?.serviceAndToolTranslation
                }
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 col-lg-8">
              <div className="calnd-info">
                {getServices?.data?.data?.content != null ? (
                  <HtmlView
                    html={LabelLangString({
                      id: "content",
                      currentLocale,
                      defaultValue: getServices?.data?.data?.content,
                      translations:
                        getServices?.data?.data?.serviceAndToolTranslation,
                    })}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <MainDepartment getDepartment={getDepartment} />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default SubscribeForm;
